<template>
  <resource
    resource="affiliate"
    resourceName="Affiliate-Code"
    :attributes="[
      {
        name: 'description',
        label: 'Beschreibung'
      },
      {
        name: 'partner',
        label: 'Werbepartner'
      },
      {
        name: 'quota',
        label: 'Kontingent'
      },
      {
        name: 'cpm',
        label: 'TKP'
      },
      {
        name: 'one_click_passing',
        label: 'One Click Passing aktivieren',
        type: 'CheckboxSelector',
        value: false
      },
      {
        name: 'with_redirect',
        label: 'Weiterleitung',
        type: 'CheckboxSelector',
        value: false,
        hr: true
      },
      {
        name: 'page',
        label: 'Seite nach Login',
        type: 'InputWithPrefixSelector',
        reverseHide: true,
        prefix: domain,
        hideable: true,
        hideEvent: 'with-redirect'
      },
      {
        name: 'with_automatic_message',
        label: 'Automatische Nachricht',
        type: 'CheckboxSelector',
        value: false,
        hr: true
      },
      {
        name: 'sender_id',
        label: 'Absender Automatische Nachricht',
        type: 'DropdownProfileSelector',
        resource: 'customerProfile',
        appends: ['primaryImage'],
        filter: [
          {
            name: 'fake'
          },
          {
            name: 'sort',
            mode: 'ASC',
            attribute: 'name'
          },
          {
            name: 'forSelect'
          },
          {
            name: 'withoutTrashed'
          },
          {
            name: 'select',
            value: ['name', 'id']
          }
        ],
        reverseHide: true,
        hideable: true,
        hideEvent: 'with-automatic-message'
      },
      {
        name: 'message',
        label: 'Nachricht(en)',
        type: 'MessagePool',
        reverseHide: true,
        hideable: true,
        hideEvent: 'with-automatic-message'
      },
      {
        name: 'delay',
        label: 'Verzögerung',
        type: 'DateRangeSliderSelector',
        max: 30,
        min: 0,
        reverseHide: true,
        hideable: true,
        hideEvent: 'with-automatic-message',
        reload: true
      },
      {
        name: 'extended_settings',
        label: 'erweiterte Filtereinstellungen',
        type: 'CheckboxSelector',
        value: false,
        hr: true
      },
      {
        value:
          'Hier kann festgelegt werden, welches Geschlecht bei der Registrierung in diese Werbekampagne mitgezählt wird und in die Statiatik fällt. Sofern Postback benutzt wird, wird dieses Ereignis nur ausgelöst, wenn das Geschlecht passt.',
        label: ' ',
        type: 'StaticText',
        reverseHide: true,
        hideable: true,
        hideEvent: 'extended-settings'
      },
      {
        value: '[0,1]',
        name: 'count_gender',
        label: 'Geschlecht zählen',
        type: 'SexSelector',
        multiSelect: true,
        reverseHide: true,
        hideable: true,
        hideEvent: 'extended-settings'
      },
      {
        name: 'requires_confirmation',
        label: 'Registrierte Mitglieder müssen ihre Daten einmal Bestätigen',
        type: 'CheckboxSelector',
        value: false
      }
    ]"
  >
    <div slot="title">
      <h4>Affiliate-Code erstellen</h4>
    </div>
  </resource>
</template>

<script lang="babel">
export default {
  computed: {
    domain() {
      return Laravel.domains[0] + "/";
    }
  }
}
</script>
